import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAssayToOrderList, clearOrderedAssays } from '@cabinet-packages/redux';
import { setGoToCollectionPoints } from '@cabinet-packages/redux/actions/actionsCreators';
import { calculateDiscountedPrice } from '../helpers/priceUtils';
import { STORAGE_KEYS } from '../helpers/constants';

/**
 * Hook for handling collection points reset when changing order
 * @param {boolean} ceil - whether to round prices
 * @returns {Object} { resetCollectionPoints, isDoctor, goToCollectionPoints }
 */
export const useCollectionPointsReset = (ceil = false) => {
    const dispatch = useDispatch();
    const { catalog, complexResearch, actions } = useSelector(state => state.assaysCatalog);
    const { orderingList, goToCollectionPoints } = useSelector(state => state.orderAssays);
    const isDoctor = localStorage.getItem(STORAGE_KEYS.IS_DOCTOR) ||
                     process.env.REACT_APP_PROJECT_NAME === 'CALCULATOR';

    const fullCatalog = useMemo(() => {
        if (!catalog || !complexResearch || !actions) return [];
        return [...catalog, ...complexResearch, ...actions];
    }, [catalog, complexResearch, actions]);

    const resetCollectionPoints = useCallback(() => {
        if (!goToCollectionPoints) return false;

        const prevOrderingList = orderingList;
        dispatch(clearOrderedAssays());

        prevOrderingList.forEach(assay => {
            const findAssay = fullCatalog.find(
                item => item.type === assay.type &&
                       +item.id === +assay.id &&
                       !item.superGroupName
            );

            if (findAssay) {
                dispatch(addAssayToOrderList(
                    findAssay.id,
                    calculateDiscountedPrice(findAssay.price, findAssay.discount, isDoctor, ceil),
                    () => {},
                    findAssay.type,
                ));
            }
        });

        dispatch(setGoToCollectionPoints(false));
        return true;
    }, [goToCollectionPoints, orderingList, fullCatalog, isDoctor, ceil, dispatch]);

    return { resetCollectionPoints, isDoctor, goToCollectionPoints };
};
